import {useCallback, useEffect, useRef, useState} from "react";
import {getItem} from "../api/itemApiClient";

// reload() resolves with the fetched item (null on failure), so a caller can
// act on the fresh data, not only re-render with it.
export const useItem = (itemId) => {
    const [item, setItem] = useState(null);
    const latestRequestRef = useRef(0);

    const reload = useCallback(async () => {
        const request = ++latestRequestRef.current;

        try {
            const data = await getItem(itemId);
            // Reloads can overlap; only the latest one may set the shown item.
            if (request === latestRequestRef.current) {
                setItem(data);
            }
            return data;
        }
        catch (error) {
            console.log(error);
            return null;
        }
    }, [itemId]);

    useEffect(() => {
        reload();
    }, [reload]);

    return {item : item, reload : reload};
};
